// Files-plane records for the ambient sky masks
// (DESIGN-WL-AMBIENT-SKIN-BACKDROP-1, HOME_AMBIENT_SKIN_SPEC §2).
//
// Keys are `ambientSkyFileKey(sky)` ('ambient/<sky>.png') and each record has
// the shape every `context.files` entry has (`{ content: { src, … } }`), so
// AmbientBackdrop resolves a sky the way an Img resolves `src: '/files/<key>'`.
// Licences: ./SOURCES.md. Never inline a data URI here (spec §2).
//
// Two build paths read this module:
//   * Parcel (the shell bundle): each literal `new URL('./<sky>.png',
//     import.meta.url)` is a URL dependency — Parcel emits the PNG with a
//     content hash and returns its served, same-origin URL (mask-image loads
//     in CORS mode, so same-origin matters).
//   * frank (esbuild to CJS for `smbls push`): `import.meta` is empty there,
//     the URL constructor throws, `_src` keeps the throw local and the record
//     is dropped — the platform JSON never carries a dead URL.
const _src = (resolve) => {
  try {
    return resolve()
  } catch (e) {
    return null
  }
}

const _masks = {
  'ambient/clouds.png': _src(() => new URL('./clouds.png', import.meta.url).href),
  'ambient/dunes.png': _src(() => new URL('./dunes.png', import.meta.url).href),
  'ambient/hills.png': _src(() => new URL('./hills.png', import.meta.url).href),
  'ambient/lake.png': _src(() => new URL('./lake.png', import.meta.url).href),
  'ambient/window.png': _src(() => new URL('./window.png', import.meta.url).href),
  'ambient/mountains.png': _src(() => new URL('./mountains.png', import.meta.url).href)
}

export default Object.fromEntries(
  Object.entries(_masks)
    .filter((entry) => typeof entry[1] === 'string' && entry[1].length > 0)
    .map((entry) => [
      entry[0],
      { content: { src: entry[1], mimeType: 'image/png', originalName: entry[0].slice(8) } }
    ])
)
